import React, { useMemo } from 'react';

interface IProps {
  count: number | string;
  final?: string;
  upper?: boolean;
  lower?: boolean;
  className?: string;
  title?: string;
  children: React.ReactNode;
  after?: React.ReactNode;
}

const Truncate: React.FC<IProps> = ({ count, final, upper, lower, className, title, children, after }) => {
  const truncatedValue = useMemo(() => {
    let value = children as string;

    if (!value || value.length < Number(count)) {
      return value;
    }

    value = value.slice(0, Number(count));

    if (final) {
      value = value + final;
    }

    if (upper) {
      value = value.toUpperCase();
    } else if (lower) {
      value = value.toLowerCase();
    }

    return value;
  }, [children, count, final, upper, lower]);

  return (
    <div className={className} title={title}>
      {truncatedValue}
      {after}
    </div>
  );
};

export default Truncate;
